export const FIRM = {
  name: "Steven Philips & Associates Limited",
  abbr: "SPA",
  established: 2002,
  rc: "RC: 722844",
  shortName: "Steven Philips & Associates",
  tagline: "Empowering Businesses. Driving Sustainable Growth.",
  address: ["2nd Avenue, 207 Road", "Suite 1", "Festac Town, Lagos", "Nigeria"],
  addressOneLine: "2nd Avenue, 207 Road, Suite 1, Festac Town, Lagos, Nigeria",
  addressHref:
    "https://www.google.com/maps/search/?api=1&query=2nd+Avenue%2C+207+Road%2C+Suite+1%2C+Festac+Town%2C+Lagos%2C+Nigeria",
  phone: "+234 803 329 6221",
  phoneHref: "tel:+2348033296221",
  phone2: "+234 802 796 1263",
  phone2Href: "tel:+2348027961263",
  email: "stephen.irebia@spalconsult.com",
  website: "https://spalconsult.com",
  websiteLabel: "spalconsult.com",
  hours: "Monday–Friday",
  hoursFull: "Monday–Friday, 8:00 AM–5:00 PM (West Africa Time)",
};

export const CEO = {
  name: "Stephen Irebia, FCA, CPA",
  plainName: "Stephen Irebia",
  position: "Managing Director & Chief Executive Officer",
  photo: "/images/stephen-irebia-ceo.jpg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1618828665011-0abd973f7bb8?w=1920&q=72&auto=format&fit=crop",
  homeIntro:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=72&auto=format&fit=crop",
  aboutOverview:
    "https://images.unsplash.com/photo-1618828665347-d870c38c95c7?w=1400&q=72&auto=format&fit=crop",
  strategy:
    "https://images.unsplash.com/photo-1529119368496-2dfda6ec2804?w=1200&q=72&auto=format&fit=crop",
  financial:
    "https://images.unsplash.com/photo-1775163024488-e88e4a71179f?w=1200&q=72&auto=format&fit=crop",
  operations:
    "https://images.unsplash.com/photo-1594538756542-8c88bda491c5?w=1200&q=72&auto=format&fit=crop",
  governance:
    "https://images.unsplash.com/photo-1716827172024-f63110d8e0f2?w=1200&q=72&auto=format&fit=crop",
  humanCapital:
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1200&q=72&auto=format&fit=crop",
};

export const SERVICE_OPTIONS = [
  "ERP & Business Software Solutions",
  "Management Consultancy",
  "Bureau & Bookkeeping Services",
  "Auditing Services",
  "Accounting Services",
  "Tax Services",
  "Financial Services",
  "Other / General Inquiry",
];

export const SERVICES = [
  {
    id: "svc-7",
    anchor: "erp-solutions",
    number: "01",
    title: "Enterprise Resource Planning (ERP) & Business Software Solutions",
    short: "ERP & Business Software",
    group: "technology",
    dropdown: "ERP & Business Software Solutions",
    homeDescription:
      "More than two decades of experience in business software reselling, Sage 300 ERP implementation, customization, training, and technical support — SPA's core service since 2002.",
    subheading:
      "Business Software Sales · Implementation · Customization · Training · Support",
    description:
      "Business software solutions that help organizations integrate operations, manage resources, improve financial visibility, and automate business processes — from selection and implementation to customization, training, and long-term support.",
    longDescription: [
      "Established in 2002, Steven Philips & Associates Limited (SPA) brings more than two decades of experience in business software reselling, ERP implementation, customization, training, and technical support.",
      "We specialize in accounting software, financial management systems, Sage 300 ERP (formerly Sage Accpac ERP), and other integrated enterprise business applications.",
      "Our services extend beyond software sales. We work with organizations to identify appropriate business software, implement and configure systems, train users, and provide ongoing technical support.",
      "By combining financial management expertise with enterprise technology capabilities, we help organizations streamline business processes, strengthen financial controls, improve operational efficiency, and support long-term growth.",
    ],
    capabilities: [
      {
        title: "Business Software Sales & Reselling",
        body: "SPA helps businesses and institutions select and acquire accounting, financial management, ERP, and other enterprise business software solutions suited to their operational requirements. Our services combine software product knowledge with professional implementation, user training, and ongoing support.",
      },
      {
        title: "Business Software Implementation & Deployment",
        body: "Providing structured ERP implementation services, including business requirements assessment, installation, configuration, system setup, and deployment.",
      },
      {
        title: "Business Software Customization & Integration",
        body: "Configuring and customizing supported ERP functionality to suit business processes, financial reporting needs, and organizational workflows.",
      },
      {
        title: "Data Migration",
        body: "Supporting the preparation, validation, and migration of relevant business data from existing systems into newly implemented ERP environments.",
      },
      {
        title: "Business Software Training",
        body: "Delivering practical training to help management teams, finance professionals, administrators, and operational users understand and effectively utilize their business software.",
      },
      {
        title: "Business Software Technical Support",
        body: "Providing technical assistance, troubleshooting, system maintenance guidance, and ongoing support to help organizations maintain effective business software operations.",
      },
      {
        title: "Business Process Automation",
        body: "Helping organizations improve operational efficiency by integrating financial and administrative processes through suitable enterprise software.",
      },
    ],
    sage: {
      title: "Sage 300 ERP & Business Software Solutions",
      paragraphs: [
        "SPA has substantial experience with Sage 300 ERP — formerly known as Sage Accpac ERP — and other Sage business software solutions, reselling, implementing, configuring, training, and supporting Sage-based accounting and enterprise business systems.",
        "This depth of experience means your Sage implementation is guided by advisers who understand not only the software, but the accounting, financial control, and business processes it must serve.",
      ],
    },
    relatedCapabilities: [
      "Accounting software implementation",
      "CRM solutions",
      "Business software development",
      "Enterprise application development",
      "Corporate website & portal development",
      "IT & information management consultancy",
    ],
    image:
      "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=1200&q=72&auto=format&fit=crop",
    alt: "A modern open-plan office with professionals working across multiple screens",
    theme: "navy",
  },
  {
    id: "svc-1",
    anchor: "management-consultancy",
    number: "02",
    title: "Management Consultancy",
    short: "Management Consultancy",
    group: "advisory",
    dropdown: "Management Consultancy",
    homeDescription:
      "Strengthening strategic direction, performance, governance, and growth across organizations.",
    description:
      "Professional management advisory services that help organizations strengthen strategic direction, improve operational performance, and achieve sustainable growth.",
    capabilities: [
      "Strategic management and business planning",
      "Organizational performance improvement",
      "Business process optimization",
      "Corporate governance advisory",
      "Operational efficiency improvement",
      "Business transformation",
      "Management training and development",
    ],
    image:
      "https://images.unsplash.com/photo-1529119368496-2dfda6ec2804?w=1200&q=72&auto=format&fit=crop",
    alt: "Executives mapping corporate strategy around a boardroom table",
    theme: "light",
  },
  {
    id: "svc-2",
    anchor: "bureau-bookkeeping",
    number: "03",
    title: "Bureau & Bookkeeping Services",
    short: "Bureau & Bookkeeping",
    group: "advisory",
    dropdown: "Bureau & Bookkeeping Services",
    homeDescription:
      "Reliable outsourced bookkeeping and financial administration for accurate records.",
    description:
      "Professional bookkeeping and outsourced financial administration services that support accurate records and effective financial management.",
    capabilities: [
      "Bookkeeping",
      "Financial transaction recording",
      "Ledger maintenance",
      "Accounts reconciliation",
      "Financial record organization",
      "Routine financial reporting support",
      "Outsourced accounting administration",
    ],
    image:
      "https://images.unsplash.com/photo-1775163024488-e88e4a71179f?w=1200&q=72&auto=format&fit=crop",
    alt: "Advisers reviewing financial records together at a desk",
    theme: "grey",
  },
  {
    id: "svc-3",
    anchor: "auditing-services",
    number: "04",
    title: "Auditing Services",
    short: "Auditing",
    group: "advisory",
    dropdown: "Auditing Services",
    homeDescription:
      "Structured audits, reviews, and control assessments that strengthen accountability.",
    description:
      "Supporting organizations with structured audit services, financial reviews, and internal control assessments designed to strengthen transparency, accountability, and financial discipline.",
    capabilities: [
      "Financial audit services",
      "Internal audit support",
      "Internal control assessments",
      "Financial compliance reviews",
      "Risk-based audit support",
      "Audit preparation assistance",
    ],
    image:
      "https://images.unsplash.com/photo-1716827172024-f63110d8e0f2?w=1200&q=72&auto=format&fit=crop",
    alt: "Monochrome photograph of a dignified corporate tower",
    theme: "light",
  },
  {
    id: "svc-4",
    anchor: "accounting-services",
    number: "05",
    title: "Accounting Services",
    short: "Accounting",
    group: "advisory",
    dropdown: "Accounting Services",
    homeDescription:
      "Reliable financial information and stronger accounting processes for sound decisions.",
    description:
      "Helping businesses and institutions maintain reliable financial information, strengthen accounting processes, and support sound financial decision-making.",
    capabilities: [
      "Financial accounting",
      "Management accounting",
      "Financial statement preparation",
      "Accounting systems advisory",
      "Accounting process improvement",
      "Financial reporting",
      "Accounting software integration",
    ],
    image:
      "https://images.unsplash.com/photo-1686061593213-98dad7c599b9?w=1200&q=72&auto=format&fit=crop",
    alt: "Financial dashboards and reports on a computer screen",
    theme: "grey",
  },
  {
    id: "svc-5",
    anchor: "tax-services",
    number: "06",
    title: "Tax Services",
    short: "Tax Services",
    group: "advisory",
    dropdown: "Tax Services",
    homeDescription:
      "Professional tax advisory and compliance support, kept current and well documented.",
    description:
      "Professional tax advisory and compliance support for organizations operating in Nigeria — structured to keep obligations current, documented, and well managed.",
    capabilities: [
      "Corporate tax advisory",
      "Tax planning",
      "Tax compliance support",
      "Tax reporting",
      "Tax documentation",
      "Tax risk assessment",
      "Tax-related financial advisory",
    ],
    image:
      "https://images.unsplash.com/photo-1762427354051-a9bdb181ae3b?w=1200&q=72&auto=format&fit=crop",
    alt: "A financial desk with calculator and tax documents",
    theme: "light",
  },
  {
    id: "svc-6",
    anchor: "financial-services",
    number: "07",
    title: "Financial Services",
    short: "Financial Services",
    group: "advisory",
    dropdown: "Financial Services",
    homeDescription:
      "Financial planning, analysis, and advisory support for informed decisions.",
    description:
      "Providing financial advisory and analytical support that helps organizations strengthen financial planning, improve resource management, and make informed business decisions.",
    capabilities: [
      "Corporate financial advisory",
      "Financial planning and analysis",
      "Budgeting and forecasting",
      "Financial performance evaluation",
      "Financial restructuring advisory",
      "Financial management systems",
      "Business financial assessments",
    ],
    image:
      "https://images.unsplash.com/photo-1594538756542-8c88bda491c5?w=1200&q=72&auto=format&fit=crop",
    alt: "Aerial view of a city's commercial district",
    theme: "grey",
  },
];

export const TECH_IMAGES = {
  erp: "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=1200&q=72&auto=format&fit=crop",
  infrastructure:
    "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?w=1200&q=72&auto=format&fit=crop",
};

export const INDUSTRIES = [
  "Public Sector & Government",
  "Banking & Financial Services",
  "Manufacturing & Distribution",
  "Commercial & Industrial",
  "Oil & Gas",
  "Energy & Utilities",
  "Hospitality & Travel",
  "Religious Organizations",
];

export const TECH_CAPABILITIES = [
  "Enterprise Resource Planning (ERP) systems",
  "Accounting software",
  "Customer Relationship Management (CRM) solutions",
  "Business application development",
  "Enterprise software implementation",
  "Enterprise website and portal development",
  "Business process automation",
  "Information technology consultancy",
  "Information management solutions",
];

export const VALUES = [
  {
    number: "01",
    title: "Established Experience",
    body: "Serving businesses and institutions since 2002.",
  },
  {
    number: "02",
    title: "Professional Advisory Expertise",
    body: "Management, accounting, audit, tax, financial, and business consulting services.",
  },
  {
    number: "03",
    title: "Enterprise Technology Solutions",
    body: "Business software sales and reselling, ERP implementation, customization, training, technical support, and enterprise application development.",
  },
];

export const AWARDS = [
  {
    date: "November 2020",
    title: "Philanthropic Personality of the Year",
    body: "Global Mindset Media Achievers Excellence Awards.",
  },
  {
    date: "September 2021",
    title: "Development in Nigeria Merit Award",
    body: "Contributions to Accounting and Financial Management.",
  },
  {
    date: "November 2021",
    title: "Exceptional Philanthropist of the Year",
    body: "Global Mindset Media Achievers Excellence Awards.",
  },
  {
    date: "December 2021",
    title: "Isoko Award of Honour",
    body: "Humanitarian Service.",
  },
  {
    date: "November 2024",
    title: "Global Grassroots Politician / Global Mindset Man of the Year",
    body: null,
  },
  {
    date: "December 2024",
    title: "Nigerian Achievement Award",
    body: "Contributions to national development in Accounting and Financial Management Services.",
  },
];

export const CREDENTIALS = [
  {
    abbr: "FCA",
    body: "Fellow, Institute of Chartered Accountants of Nigeria (FCA).",
  },
  {
    abbr: "CPA",
    body: "Certified Public Accountant (CPA), New York Chapter.",
  },
];

export const EXPERTISE_AREAS = [
  {
    title: "Audit and Financial Advisory",
    body: "Over 30 years of professional experience supporting financial oversight, compliance, and strategic business decisions.",
  },
  {
    title: "Corporate Restructuring and Business Turnaround",
    body: "Experience in financial restructuring and initiatives aimed at restoring organizational stability and strengthening business performance.",
  },
  {
    title: "Corporate Governance and Risk Management",
    body: "Expertise in governance structures, financial controls, accountability, and risk mitigation.",
  },
  {
    title: "Tax and Financial Strategy",
    body: "Advisory experience in tax planning, corporate financial management, and compliance.",
  },
  {
    title: "Strategic Leadership",
    body: "Experience advising organizations on complex management and financial decisions.",
  },
];

export const CORE_VALUES = [
  {
    title: "Integrity",
    body: "Maintaining the highest ethical standards in every engagement.",
  },
  {
    title: "Excellence",
    body: "Delivering rigorous, premium quality solutions without compromise.",
  },
  {
    title: "Innovation",
    body: "Finding forward-thinking approaches to modern corporate challenges.",
  },
  {
    title: "Collaboration",
    body: "Working hand-in-hand with our clients to ensure execution matches intent.",
  },
];

export const COMMITTEES = [
  "Finance Committees",
  "Budget & Appropriations Committees",
  "Public Accounts Committees",
];
